import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { NextAction, UndoneSession } from './types';

export type AIMonitorWatchmenPluginState = {
	currentSession: {
		aiOutputChars: number;
		aiOutputWords: number;
		awaitingNextAction: boolean;
		baselineDoc: PMNode;
		id: string;
		mergedNewRanges: Array<{ from: number; to: number }>;
		ranges: { newEnd: number; newStart: number; oldEnd: number; oldStart: number }[];
		startedAt: number;
	} | null;

	/**
	 * This is the total count of times that the feedback collector has been invoked.
	 */
	feedbackSubmissions: number;

	lastUndoneSession: UndoneSession | null;

	pendingAnalytics: {
		aiOutputChars: number;
		aiOutputWords: number;
		aiSessionId: string;
		nextActionLatencyMs: number;
		nextActionRemovedAiChars: number | undefined;
		nextActionRemovedAiWords: number | undefined;
		nextActionTouchedAiRanges: number | undefined;
		nextActionType: NextAction;
	} | null;
};

export const aiMonitorWatchmenPluginKey = new PluginKey<AIMonitorWatchmenPluginState>(
	'aiMonitorWatchmen',
);
